/** `/$org/apps/contract-intelligence/settings`: the organization's defaults (admins change them). */
import { createFileRoute } from "@tanstack/react-router";

import { CiSettingsPage } from "../components/apps/contractIntelligence/CiSettingsPage";

export const Route = createFileRoute("/$org/apps/contract-intelligence/settings")({
  component: CiSettingsPage,
});
